<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{$t('admin.views.services.h1')}}</h1>
      <div class="services-content flex justify-between">
        <div class="services-content-column">
          <div class="services-content-block">
            <div class="services-content-block-header">
              <div class="name flex items-center">
                <span>{{$t('admin.views.services.polish')}}</span>
              </div>
              <div class="setting flex items-center">
                <button
                  class="rounded flex justify-center items-center focus:outline-none"
                  @click="
                    $store.dispatch('settings/set', {
                      key: 'use_polish',
                      value: settings.use_polish == '1' ? '0' : '1',
                    })
                  "
                >
                  <span class="check"><i
                      v-if="settings.use_polish == '1'"
                      class="fas fa-check text-red-500"
                    ></i></span>
                  <span class="ml-2 text-sm">{{$t('admin.views.services.use_polish')}}</span>
                </button>
              </div>
            </div>
            <div class="services-content-block-body">
              <div class="font-bold mb-2">{{$t('admin.views.services.stela')}}</div>

              <div class="mb-6">
                <button
                  class="btn btn-default btn-small"
                  @click="formData = { type: 'polish', element_group: 'stely' }"
                >
                  {{$t('admin.views.services.button_create_complect_polish')}}
                </button>
              </div>
              <div
                class="list-add-works"
                v-if="works.polish && works.polish.stely"
              >
                <Item
                  :work="work"
                  :index="index"
                  v-for="(work, index) in works.polish.stely"
                  :key="work.work_additional_id"
                />
              </div>
            </div>
            <div class="services-content-block-body">
              <div class="font-bold mb-2">{{$t('admin.views.services.thumb')}}</div>
              <div class="mb-6">
                <button
                  class="btn btn-default btn-small"
                  @click="formData = { type: 'polish', element_group: 'tumby' }"
                >
                  {{$t('admin.views.services.button_create_complect_polish')}}
                </button>
              </div>
              <div
                class="list-add-works"
                v-if="works.polish && works.polish.tumby"
              >
                <Item
                  :work="work"
                  :index="index"
                  v-for="(work, index) in works.polish.tumby"
                  :key="work.work_additional_id"
                />
              </div>
            </div>
            <div class="services-content-block-body">
              <div class="font-bold mb-2">{{$t('admin.views.services.cvetniki_nadgrobiya')}}</div>
              <div class="mb-6">
                <button
                  class="btn btn-default btn-small"
                  @click="
                    formData = {
                      type: 'polish',
                      element_group: 'cvetniki_nadgrobiya',
                    }
                  "
                >
                  {{$t('admin.views.services.button_create_complect_polish')}}
                </button>
              </div>
              <div
                class="list-add-works"
                v-if="works.polish && works.polish.cvetniki_nadgrobiya"
              >
                <Item
                  :work="work"
                  :index="index"
                  v-for="(work, index) in works.polish.cvetniki_nadgrobiya"
                  :key="work.work_additional_id"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="services-content-column">
          <div class="services-content-block">
            <div class="services-content-block-header">
              <div class="name flex items-center">
                <span>{{$t('admin.views.services.install')}}</span>
              </div>
              <div class="setting flex items-center">
                <button
                  class="rounded flex justify-center items-center focus:outline-none"
                  @click="
                    $store.dispatch('settings/set', {
                      key: 'use_install',
                      value: settings.use_install == '1' ? '0' : '1',
                    })
                  "
                >
                  <span class="check"><i
                      v-if="settings.use_install == '1'"
                      class="fas fa-check text-red-500"
                    ></i></span>
                  <span class="ml-2 text-sm">{{$t('admin.views.services.use_install')}}</span>
                </button>
              </div>
            </div>
            <div class="services-content-block-body">
              <div class="mb-6">
                <button
                  class="btn btn-default btn-small"
                  @click="
                    formData = {
                      type: 'install',
                      element_group: null,
                    }
                  "
                >
                  {{$t('admin.views.services.button_add_install')}}
                </button>
              </div>
              <div class="list-add-works">
                <Item
                  :work="work"
                  :index="index"
                  v-for="(work, index) in works.install"
                  :key="work.additional_work_id"
                />
              </div>
            </div>
            <div class="services-content-block-body">
              <div class="font-bold mb-4">{{$t('admin.views.services.auto_add_install_with_landscaping')}}</div>

              <div class="mb-4 relative">
                <div
                  v-if="!works.install"
                  class="absolute w-full h-full bg-white opacity-75 left-0 top-0"
                ></div>
                <button
                  class="flex items-center focus:outline-none"
                  @click="
                    $store.dispatch('settings/set', {
                      key: 'landscaping_auto_install',
                      value: settings.landscaping_auto_install == '1' ? '0' : '1',
                    })
                  "
                >
                  <span>
                    <span class="check"><i
                        v-if="settings.landscaping_auto_install == '1'"
                        class="fas fa-check text-red-500"
                      ></i></span>
                  </span>

                  <span class="ml-2 text-sm text-left">{{$t('admin.views.services.auto_add_install_with_landscaping_is_active')}}</span>
                </button>
              </div>

              <div
                class="form-group"
                v-if="works.install"
              >
                <div class="text-sm mb-4">{{$t('admin.views.services.choose_install_type')}}</div>
                <div class="flex items-center">
                  <select @change="e=>$store.dispatch('settings/set', {
                      key: 'landscaping_auto_install_id',
                      value: e.target.value,
                    })">
                    <option :value="0">{{$t('main.select_placeholder')}}</option>
                    <option
                      v-for="(work, index) in works.install"
                      :key="`works-instal-${work.additional_work_id}`"
                      :value="work.additional_work_id"
                      :selected="settings.landscaping_auto_install_id==work.additional_work_id"
                    >
                      {{ work.name }}
                    </option>
                  </select>
                </div>

              </div>
              <div
                v-else
                class="text-sm text-red-500"
              >{{$t('admin.views.services.no_variants_install')}}</div>

            </div>
          </div>
        </div>
        <div class="services-content-column">
          <div class="services-content-block">
            <div class="services-content-block-header">
              <div class="name flex items-center">
                <span> {{$t('admin.views.services.additional_services')}} </span>
              </div>
              <div class="setting flex items-center">
                <button
                  class="rounded flex justify-center items-center focus:outline-none"
                  @click="
                    $store.dispatch('settings/set', {
                      key: 'use_services',
                      value: settings.use_services == '1' ? '0' : '1',
                    })
                  "
                >
                  <span class="check"><i
                      v-if="settings.use_services == '1'"
                      class="fas fa-check text-red-500"
                    ></i></span>
                  <span class="ml-2 text-sm">{{$t('admin.views.services.use_additional_services')}}</span>
                </button>
              </div>
            </div>
            <div class="services-content-block-body">
              <div class="mb-6">
                <button
                  class="btn btn-default btn-small"
                  @click="
                    formData = {
                      type: 'service',
                      element_group: null,
                    }
                  "
                >
                  {{$t('admin.views.services.button_additional_services')}}
                </button>
              </div>
              <div class="list-add-works">
                <Item
                  :work="work"
                  :index="index"
                  v-for="(work, index) in works.service"
                  :key="work.additional_work_id"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-if="formData"
      @close-modal="formData = null"
    >
      <div class="font-bold mb-30">Добавить</div>
      <Form
        :formData="formData"
        @additional-work-saved="additionalWorkSaved"
      />
    </Modal>
  </div>
</template>
<script>
import Item from "../../components/Admin/AdditionalWorks/Item.vue";
import Form from "../../components/Admin/AdditionalWorks/Form.vue";
export default {
  components: { Item, Form },
  data() {
    return {
      formData: null,
    };
  },
  mounted() {
    if (!this.licensed) this.$router.push({ name: "no_license" });
    this.$store.dispatch("additionalWorks/fetch");
  },
  computed: {
    licensed() {
      return this.$store.getters["licensed"];
    },
    works() {
      return this.$store.state.additionalWorks.works;
    },
    settings() {
      return this.$store.state.settings.settings;
    },
  },
  methods: {
    additionalWorkSaved() {
      this.formData = null;
      this.$store.dispatch("additionalWorks/fetch");
    },
  },
  watch: {
    works(works) {
      if (!works.install) {
        this.$store.dispatch("settings/set", {
          key: "landscaping_auto_install",
          value: "0",
        });
        this.$store.dispatch("settings/set", {
          key: "landscaping_auto_install_id",
          value: "0",
        });
      }
    },
  },
};
</script>
